import { z } from 'zod';

export const ERRORS = {
  email: {
    non_unique: 'Email has already been verified by another account',
    invalid: 'Please provide a valid email address',
  },
};

const EmailNotificationsFieldSchema = z.object({
  email: z
    .string({ required_error: ERRORS.email.invalid })
    .email(ERRORS.email.invalid)
    .or(z.literal('')),
});

const EmailNotificationsErrorSchema = z.object({
  email: z.string().nullish(),
});

const EmailNotificationsTouchedSchema = z.object({
  email: z.boolean(),
});

export const EmailNotificationsSchema = z.object({
  fields: EmailNotificationsFieldSchema,
  errors: EmailNotificationsErrorSchema,
  touched: EmailNotificationsTouchedSchema,
  artistUpdates: z.boolean(),
});

export type EmailNotificationsState = z.infer<typeof EmailNotificationsSchema>;

export const initialEmailNotificationState = () =>
  ({
    fields: {
      email: '',
    },
    errors: {
      email: null,
    },
    touched: {
      email: false,
    },
    artistUpdates: false,
  }) satisfies EmailNotificationsState;
